<template>
  <div style="font-size:17px">
    <div v-if="promoterCurrent.partyType == 'PromoterIndividual'">
      <div style="font-size:20px;text-align: center">
        <b>نوع شخصیت : حقیقی</b>
      </div>
      <div class="vx-row my-6">
        <div class="vx-col lg:w-1/2 w-full" style="font-size:18px">
          <label for="">نام : </label>{{ promoterCurrent.firstName
          }}{{ promoterCurrent.lastName }}
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">تاریخ ایجاد : </label
          >{{ promoterCurrent.persianCreateOn }}
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">کد ملی : </label
          >{{ promoterCurrent.socialSecurityNumber }}
        </div>
      </div>
      <div class="vx-row mb-6" v-if="promoter.birthCertificateNumber">
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">شماره شناسنامه : </label
          >{{ promoterCurrent.birthCertificateNumber }}
        </div>
      </div>
    </div>
    <div v-else>
      <div style="font-size:20px;text-align: center">
        <b>نوع شخصیت : حقوقی</b>
      </div>
      <div class="vx-row my-6">
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">نام شرکت : </label>{{ promoterCurrent.companyName }}
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">شناسه ملی : </label
          >{{ promoterCurrent.companyNationalId }}
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">شماره ثبت : </label
          >{{ promoterCurrent.companyRegistrationNumber }}
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/2 w-full">
          <label for="">کد اقتصادی : </label>{{ promoterCurrent.economicCode }}
        </div>
      </div>
    </div>

    <div class="vx-row my-6">
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">شماره تلفن : </label
        >{{ promoterCurrent.phonesQuery[0].area }}-{{
          promoterCurrent.phonesQuery[0].number
        }}
      </div>
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">ایمیل : </label>{{ promoterCurrent.emailAddress }}
      </div>
    </div>
    <div class="vx-row my-6">
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">آدرس : </label
        >{{ promoterCurrent.addressInfoQuery[0].address }}
      </div>
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">کد پستی : </label
        >{{ promoterCurrent.addressInfoQuery[0].postalCode }}
      </div>
    </div>
    <div class="vx-row my-6">
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">استان : </label
        >{{ promoterCurrent.addressInfoQuery[0].provinceInfo.name }}
      </div>
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">شهر : </label
        >{{ promoterCurrent.addressInfoQuery[0].provinceInfo.cityName }}
      </div>
    </div>
    <div class="vx-row my-6">
      <div class="vx-col lg:w-1/2 w-full">
        <label for="">مانده اعتبار : </label>{{ amountCirrent }}
      </div>
    </div>
    <div class="vx-row my-6">
      <div class="vx-col w-full">
        <label for="">آدرس لینک همیار فروش : </label
        ><a :href="UrlCurrent"
          >https://www.avajang.com/?referralCode={{ referralcodeId }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import myUpload from "vue-image-crop-upload";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
    quillEditor,
    "my-upload": myUpload
  },
  data() {
    return {
      UrlCurrent: "",
      amountCirrent: "",
      promoter: {},
      promoterCurrent: {},
      model: {},
      referralcodeId: ""
    };
  },
  computed: {
    ...mapGetters({
      actualProduct: "actualProduct/details",
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list",
      loading: "actualProduct/loading"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      PartiesQueryDetailswithid: "SalesPartnerPlan/PartiesQueryDetailswithid"
    }),
    load() {
      var id = this.$route.params.id;
      this.referralcodeId = id;
      this.promoterCurrent = this.$route.query.promoter2;

      this.PartiesQueryDetailswithid(id).then(r => {
        this.amountCirrent = r.amount;
      });
    }
  }
};
</script>

<style scoped>
label {
  font-weight: bold;
  font-size: 20px;
}
</style>
